import PlanningHebdomadaire from './PlanningHebdomadaire';

/** Même contenu que Planning Hebdomadaire — route dédiée admin (iOS). */
const PlanningHebdoIos = () => <PlanningHebdomadaire />;

export default PlanningHebdoIos;
